import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  TypeaheadModule,
  ModalModule,
  BsDropdownModule,
  AlertModule,
} from "ngx-bootstrap";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { TabsModule } from "ngx-bootstrap/tabs";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { KeysPipe } from "@app/utility/pipe";
import { EllipsisPipe } from "@app/utility/pipes/ellipsis-pipe";
import { CapitalizePipe } from "@app/utility/pipes/capitalize-pipe";
import { CleanStringPipe } from "@app/utility/pipes/string-pipe";
import { Collapse } from "@app/utility/components/collapse/collapse.component";
import { ButtonDropDownComponent } from "@app/utility/components/button-dropdown/button-dropdown.component";
import { ModalePreviewComponent } from "@app/utility/components/modale-preview-pdf/modale-preview-pdf.component";
import { AlberoSettoriComponent } from "./components/albero-settori/albero-settori.component";
import {
  MatTreeModule,
  MatProgressBarModule,
  MatCheckboxModule,
  MatProgressSpinnerModule,
  MatTooltipModule,
  MatSelectModule,
} from "@angular/material";
import { MyDatePickerModule } from "mydatepicker";
import { FileUploadModule } from "ng2-file-upload";
import { ModaleControlloFirmaComponent } from "@app/shared/components/modale-controllo-firma/modale-controllo-firma.component";
import { ModaleConfermaComponent } from "@app/shared/components/modale-conferma/modale-conferma.component";
import { SlimLoadingBarModule } from "ng2-slim-loading-bar";
import { PrettyPrintPipe } from "./pipes/prettyprint-pipe";
import { ModaleInfoComponent } from "@app/shared/components/modale-info/modale-info.component";
import { ModaleConfermaDownloadVerbaleComponent } from "@app/shared/components/modale-conferma-download-verbale/modale-conferma-download-verbale.component";
import { ModaleConfermaWarningVerbaleComponent } from "@app/shared/components/modale-conferma-warning-verbale/modale-conferma-warning-verbale.component";
import { ModaleVersioniDocumentoComponent } from "@app/shared/components/modale-versioni-documento/modale-versioni-documento.component";
import { GiorniDaPipe } from "./pipes/giorni-da.pipe";
import { ModaleAttesaComponent } from "./components/modale-attesa/modale-attesa.component";
import { TabDestinatariComponent } from "@app/shared/components/tab-destinatari/tab-destinatari.component";
import { TabDestinatariDipendentiComponent } from "@app/shared/components/tab-destinatari-dipendenti/tab-destinatari-dipendenti.component";
import { TabDestinatariInterniComponent } from "@app/shared/components/tab-destinatari-interni/tab-destinatari-interni.component";
import { ContactChipComponent } from "./components/contact-chip/contact-chip.component";
import { ContactListComponent } from "./components/contact-list/contact-list.component";
import { ModaleProvvisoriComponent } from "./components/modale-provvisori/modale-provvisori.component";
import { ModaleSoggettiAlternativiComponent } from "./components/modale-soggetti-alternativi/modale-soggetti-alternativi.component";
import { ModaleDettaglioSoggettoRecapitoComponent } from "@app/shared/components/modale-dettaglio-soggetto-recapito/modale-dettaglio-soggetto-recapito.component";
import { ReplaceUnderscorePipe } from "./pipes/replace-underscore-pipe";
import { ModaleIndicazioniComponent } from "@app/shared/components/modale-indicazioni/modale-indicazioni.component";
import { LabelStoricoPipe } from "./pipes/label-storico.pipe";
import { DimensioniFilePipe } from "./pipes/dimensioni-file-pipe";
import { ModaleConfermaChiudiFascicoloComponent } from "@app/shared/components/modale-conferma-chiudi-fascicolo/modale-conferma-chiudi-fascicolo.component";
import { PulisciNomeCampoPipe } from "./pipes/pulisci-nome-campo.pipe";
import { PdfjsViewerComponent } from "@app/shared/components/pdfjs-viewer/pdfjs-viewer.component";
import { ModaleVisibilitaAttoComponent } from "@app/shared/components/modale-visiblita-atto/modale-visibilita-atto.component";
import { LabelStatoAttiPipe } from "./pipes/label-stato-atti.pipe";
import { FilterJoinPipe } from "./pipes/filter-join-pipe";

@NgModule({
  imports: [
    TypeaheadModule.forRoot(),
    CommonModule,
    FormsModule,
    TabsModule,
    NgxDatatableModule,
    MatSelectModule,
    FileUploadModule,
    BsDropdownModule.forRoot(),
    ModalModule.forRoot(),
    PdfViewerModule,
    MatTreeModule,
    MatProgressBarModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MyDatePickerModule,
    SlimLoadingBarModule,
    AlertModule,
    MatTooltipModule,
    ReactiveFormsModule
  ],
  declarations: [
    Collapse,
    KeysPipe,
    EllipsisPipe,
    FilterJoinPipe,
    DimensioniFilePipe,
    CapitalizePipe,
    CleanStringPipe,
    PrettyPrintPipe,
    ReplaceUnderscorePipe,
    GiorniDaPipe,
    LabelStoricoPipe,
    LabelStatoAttiPipe,
    PulisciNomeCampoPipe,
    ButtonDropDownComponent,
    ModalePreviewComponent,
    AlberoSettoriComponent,
    ModaleControlloFirmaComponent,
    ModaleInfoComponent,
    ModaleConfermaDownloadVerbaleComponent,
    ModaleConfermaWarningVerbaleComponent,
    ModaleConfermaComponent,
    ModaleVisibilitaAttoComponent,
    ModaleConfermaChiudiFascicoloComponent,
    ModaleVersioniDocumentoComponent,
    ModaleAttesaComponent,
    ContactChipComponent,
    ContactListComponent,
    ModaleProvvisoriComponent,
    ModaleSoggettiAlternativiComponent,
    ModaleDettaglioSoggettoRecapitoComponent,
    ModaleIndicazioniComponent,
    PdfjsViewerComponent,
  ],
  exports: [
    GiorniDaPipe,
    LabelStoricoPipe,
    LabelStatoAttiPipe,
    ReplaceUnderscorePipe,
    Collapse,
    EllipsisPipe,
    FilterJoinPipe,
    DimensioniFilePipe,
    CleanStringPipe,
    PulisciNomeCampoPipe,
    KeysPipe,
    CapitalizePipe,
    AlberoSettoriComponent,
    ButtonDropDownComponent,
    ModalePreviewComponent,
    ModaleProvvisoriComponent,
    ModaleSoggettiAlternativiComponent,
    ModaleDettaglioSoggettoRecapitoComponent,
    ModaleAttesaComponent,
    ModaleControlloFirmaComponent,
    ModaleInfoComponent,
    ModaleConfermaDownloadVerbaleComponent,
    ModaleConfermaWarningVerbaleComponent,
    ModaleConfermaComponent,
    ModaleConfermaChiudiFascicoloComponent,
    ModaleIndicazioniComponent,
    ModaleVersioniDocumentoComponent,
    ModaleVisibilitaAttoComponent,
    ContactChipComponent,
    ContactListComponent,
  ],
})
export class UtilityModule { }
